import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { observable } from 'mobx';


interface BroadcastNotificationProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class BroadcastNotification extends React.Component<BroadcastNotificationProps, any> {
	constructor(props) {
		super(props);

	}

	@observable
	title: string;

	@observable
	body: string;

	public componentDidMount() {
		if (this.props.values)

			this.title = this.props.values['title'];
			this.body = this.props.values['body'];

			this.props.values.validate = () => {

				if (!this.props.values['title'])
					return { result: false, errors: "The title is required for BroadcastExecutor. \n" };

				if (!this.props.values['body'])
					return { result: false, errors: "The body is required for BroadcastExecutor. \n" };

				return { result: true, errors: "" };
			}
	}

	render() {

		const { values } = this.props;
		
		return (
			<React.Fragment>

				<Row gutter={24}>
					<Col xs={24}>
						<p>The Body field will be rendered using Razor Engine. The injected viewmodel will be the rule event, watch out the available fields</p>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col xs={12}>
						<TextView
							label='Notification title'
							mode={this.props.mode}
							value={this.title}
							onChanged={(e) => {
								this.title = e;
								this.props.onFieldChange("title", e)
							}
							}
						/>
					</Col>
				</Row>
				
				<Row gutter={24}>

					<Col xs={24}>
						<RichTextView
							label='Notification body'
							mode={this.props.mode}
							value={this.body}
							onChanged={(e) => {
								this.body = e;
								this.props.onFieldChange("body", e)
							}
							}
						/>

					</Col>
				</Row>
			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/broadcast-notification-executor.tsx